@if (mode() === 'edit') {
    <div class="flex flex-col gap-medpace-field">
        @for (error of formGroup().errors | keyvalue; track error.key) {
            <medpace-alert [appearance]="'danger'" [content]="error.value" />
        }
        <div class="grid grid-cols-2 gap-medpace-field">
            <medpace-datepicker
                id="lodgingCheckInDate"
                [label]="'Check-in Date'"
                [appearance]="'outline'"
                [formCtrl]="formGroup().controls.checkInDate"
            />
            <medpace-datepicker
                id="lodgingCheckOutDate"
                [label]="'Check-out Date'"
                [appearance]="'outline'"
                [formCtrl]="formGroup().controls.checkOutDate"
            />
        </div>
        <medpace-textarea-autocomplete
            id="specialRequests"
            [autoSize]="true"
            [cdkAutosizeMaxRows]="20"
            [cdkAutosizeMinRows]="5"
            [label]="'Special Requests'"
            [placeholder]="'Special requests - e.g. hotel preference, room size, ADA accessible'"
            [appearance]="'outline'"
            [formCtrl]="formGroup().controls.specialRequests"
            [options]="autocompleteOptions().specialRequests"
        />
    </div>
} @else if (mode() === 'view') {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Check-in Date</h5>
                    <span>{{ formGroup().controls.checkInDate.value?.toDate() | dateFormat | uppercase }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Check-out Date</h5>
                    <span>{{ formGroup().controls.checkOutDate.value?.toDate() | dateFormat | uppercase }}</span>
                </div>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item m-0">
                <div class="c-info__block">
                    <h5>Special requests</h5>
                    <span>{{ formGroup().controls.specialRequests.value ?? 'Unspecified' }}</span>
                </div>
            </div>
        </div>
    </div>
}
